export default "__VITE_ASSET__1ad6fced__"